/**
 * Type: コンポーネント
 * What: 投稿リスト
 */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import SEO from './Seo';
import BreadcrumbComponent from './Breadcrumb';
import CategoriesComponent from './Categories';
import CategoryDescription from '../util/categoriesDescription';

import Card from './PostList/Card';

class PostPage extends React.Component {
  render() {
    const {
      posts,
      title,
      description,
      baseUrl,
      category,
    } = this.props;

    return (
      <>
        <SEO
          title={category ? `ニュース｜${category}｜${title}` : title}
          description={category ? CategoryDescription(category) : description}
        />
        {category ? (
          <>
            <BreadcrumbComponent
              hierarchy={3}
              bread2title={title}
              bread2url={baseUrl}
              bread3title={category}
              classname="pc"
            />
          </>
        ) : (
          <>
            <BreadcrumbComponent hierarchy={2} bread2title={title} />
          </>
        )}
        <section className="section">
          <div className="container">
            <h2 className="headline"><span>Topics</span></h2>
            <CategoriesComponent categoryName={category} />
            <div className="columns is-multiline is-10 is-offset-1">
              {posts.map(({ node: post }) => (
                <div className="column is-3" key={post.id}>
                  <Card {...post} />
                </div>
              ))}
            </div>
          </div>
        </section>
      </>
    );
  }
}

PostPage.defaultProps = {
  posts: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  CloseSimple: PropTypes.bool,
};

export const pageQuery = graphql`
  fragment PostListFields on wordpress__POST {
    id
    title
    excerpt
    date(formatString: "YYYY.MM.DD")
    slug
    path
    featured_media {
      source_url
    }
    categories {
      id
      slug
      name
    }
  }
`;

export default PostPage;
